import $ from '../_snowpack/pkg/jquery.js';
import Auth from'./auth.js';
import Bookmark from './bookmark.js';
import Users from'./users.js';

function removeCrown(){
  if( $('.bt-crown').hasClass('turnPink') ){
  	$('.crown').css('border','4px solid #4bbdfe');
  	$('.bt-crown').removeClass('turnPink');
  	$('.searchbox').val('').keyup();
  	$('.searchbox').css('background','white').css('color','#a7a9ac');
  }   	
}

const Navigation = {
  isCollapsed: false,
  nav: 'filters',
  init: function(menu, submenu) {
    this.setClickHandlers(menu, submenu);
    this.setFilters(menu);
    if (!this.isCollapsed) $(`.${this.nav}-content`).show();
    $(`.${this.nav} i`).addClass('active');
  },
  setClickHandlers: function(menu, submenu) {
    $('.collapsible').on('click', function() {
    	$('.toprightblock').css('display','none');
      this.isCollapsed = !this.isCollapsed;
      const collapseClass = this.isCollapsed ? 'bt-plus-square' : 'bt-minus';
      $(this).find('i').removeClass('bt-minus bt-plus-square').addClass(collapseClass);
      if(collapseClass=='bt-plus-square'){
      	removeCrown();
      	$('.crown').hide();
      	$('.navtitle').hide();
      	$('.addrev').remove();
      	$('.searchbox').hide();
        $('.statusSelect').hide()
      } else{
      	$('.close-spot').click();

	    	if( $('.bt-ulist').hasClass('active')==true){
	    		$('.crown').show();
	    		$('.searchbox').show();
	    		$('.navtitle').show();
	    	} else if($('.bt-calendar').hasClass('active')==true){
      		$('.navtitle').show();
      		$('.addrev').show();
	    	} else if($('.bookmark .bt-heart').hasClass('active')){
          //alert('hasit');
          $('.statusSelect').show();
          //setTimeout(() => $('.statusSelect').show(), 1000);
        }

      }
      $('.navigation').toggleClass('closed').css({ width: (this.isCollapsed) ? 30: 320, height: (this.isCollapsed) ? 30 : 'auto' }, 200);
    });

    $('.bookmark, .filters, .calendars, .neighborhoods').on('click', function() {
    	$('.close-spot').click();
    	const erOpen = $('#open').is(':checked');
    	if(erOpen==true){
    		$('.openlabel').css('color','#cdcdcd');
    		$('#open').click();
    	}
    });

    $('.bookmark, .filters').on('click', function() {
      if ($(this).prop('class') === 'bookmark' && !Auth.isLoggedIn) return;
      $('.nav').find('.active').removeClass('active');
      $(this).find('i').addClass('active');
      const className = $(this).prop('class');
      $('.nav-content > li').hide();
      $(`.${className}-content`).show();
    });

    $('.bookmark').on('click', () => {
    	$('.addrev').remove();
    	$('.navtitle').hide();
      if (!Bookmark.bookmarks || !Auth.isLoggedIn) return;
      $('.imglogo span').text('Favorites');
      window.updateMarkers(Bookmark.bookmarks);
    	Users.init(Auth.uid, true);
    });

		$('.filters').on('click', () => { window.revertSpots();$('.addrev').remove(); });

    $('.calendars,.filters').on('click', function() {
    	$('.navtitle').show();
      if ($(this).prop('class') === 'bookmark' && !Auth.isLoggedIn) return;
      $('.nav').find('.active').removeClass('active');
      $(this).find('i').addClass('active');
      const className = $(this).prop('class');
      $('.nav-content > li').hide();
      $(`.${className}-content`).show();
    });

		function asc_sort(a, b){
		    return ($(b).text()) < ($(a).text()) ? 1 : -1;    
		}

		function dec_sort(a, b){
		    return ($(b).text()) > ($(a).text()) ? 1 : -1;    
		}
		
    $('.filters-content ul, .calendars-content').on('change', 'input', function() {
      $('.blocker').css('display','flex');
      const collection = [];
      const isOpen = $('#open').is(':checked');
      $('.filters-content input:checked:not(#open)').each(function() { collection.push($(this).prop('id')); });
      const groups = Object.values(menu).filter((m) => collection.includes(m.cat));
      if (collection.length) {
	      if($(this).attr('id')=='open'&&isOpen==true){
	      } 

        window.filterByGroup(groups, isOpen);	      	

        $('.imglogo span').text(`All ${collection.join(', ')}`);
      	$('.blocker').css('display','none');
      } else {
        const params = new URLSearchParams(window.location.search);
        const param = params.get('g');
        const caram = params.get('c');
        setTitle({ menu, submenu }); 
        updateMarkers(window.spots.filter(spot => spot.groups[param]), isOpen);
      	$('.blocker').css('display','none');
      }

    });
  },
  setFilters: function(menu) {
    menu.filter((o) => o.active).forEach(item => {
      $('.filters-content ul, .calendars-content ul').append($('<li>').html(`
      <div class="filter-container">
        <input type="checkbox" name="checkname" id="${item.cat}" />
        <label for="${item.cat}" style="color: ${item.color}">All ${item.cat}</label>
      </div>`))
    });
  }
}

export default Navigation;
